export default "__VITE_ASSET__ociWJGJp__"